import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Bem from 'bemHelper';
import apiDecorator from 'api/api-decorator';
import { reportError } from 'api/api-errors';
import { emit } from 'helpers/global-events';
import Tree from 'components/dynamic-tree';
import { Checkbox, InputLabel } from 'containers/form';
import Button, { btnThemes } from 'components/button';
import { iconTypes } from 'components/icon';
import Notification from 'components/notification';
import Row, { Col } from 'components/row';
import LayoutContainer, { Stretch, Fixed } from 'components/layout-container';
import ScrollComponent from 'components/scroll-component';

import ForumIcons from '../../../../backoffice/section-admin/forum/help/forum-icons';

const classesBemForm = new Bem('modalContentAdmin');
const classesBemInfiniteTree = new Bem('infinite-tree');

@apiDecorator
export default class MoveThemeContent extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    listBoxItems: PropTypes.arrayOf(PropTypes.shape({})),
    onResetSelection: PropTypes.func
  };

  // Action for closing modal window
  static contextTypes = {
    close: PropTypes.func.isRequired
  };

  constructor(...args) {
    super(...args);
    this.onTreeChange = this.onTreeChange.bind(this);
    this.moveTopics = this.moveTopics.bind(this);
    this.treeItemRenderer = this.treeItemRenderer.bind(this);

    this.state = {
      chosenTopic: null,
      forum_id: null,
      forum_parent: null,
      tree: undefined,
      needLink: false
    };
  }

  onTreeChange({ id, tree, parent }) {
    this.setState({ tree });
    this.setState({ forum_id: id });
    this.setState({ forum_parent: parent });
  }

  /**
   * Move topics to another forum in DB.
   *
   * @param topics
   */
  moveTopics(topics) {
    const { forum_id: target, needLink, forum_parent } = this.state

    if (!forum_parent) return Notification.error('Невозможно переместить тему в категорию');

    if (target) {
      this.api.post('action/forum/actions-move-topics/move', {
        postData: {
          topics,
          target,
          needLink
        }
      })
        .then(() => this.afterMoveTopics(topics))
        .catch(error => reportError(error));

      this.setState({
        tree: undefined,
        forum_id: null,
        forum_parent: null
      });
    }
  }

  // Call after success merge topics.
  afterMoveTopics(topics) {
    Notification.success('Тема успешно перенесена.');

    if (topics.length > 0 && this.context && this.context.close) this.context.close();

    this.props.onResetSelection(false, topics);

    // Update topics.
    emit('updateClubTopics');
  }

  treeItemRenderer(val) {
    const forumTitle = val.forum_title;
    const forumType = val.forum_type;

    return (
      <>
        <ForumIcons {...classesBemInfiniteTree('icon')} forumType={forumType} />
        <span
          {...classesBemInfiniteTree('text')}
          dangerouslySetInnerHTML={{ __html: forumTitle }} // eslint-disable-line
        />
      </>
    );
  }

  render() {
    const { className, listBoxItems } = this.props;

    return (
      <ScrollComponent {...classesBemForm({ extra: className })}>
        <div {...classesBemForm('flexColumn')}>
          <LayoutContainer>
            <Stretch>
              <Row>
                <Col allPr={0}>
                  <InputLabel
                    {...classesBemForm('label')}
                    schema={{ label: 'Выберите форум в который переносим тему:' }}
                  />
                  <Tree
                    {...classesBemForm('tree')}
                    onSelect={this.onTreeChange}
                    selected={this.state.tree}
                    dataProvider="admin/forum/tree-list"
                    query={{ 'order-by': 'weight', withoutLink: true }}
                    itemRenderer={this.treeItemRenderer}
                    loadOnDemand={false}
                    updateEvent="updateForum"
                    // treeHeight={500}
                    // staticTreeHeight
                  />
                </Col>
              </Row>
            </Stretch>
            <Fixed {...classesBemForm('footer')}>
              <Row allAuto {...classesBemForm('btnsContainer')}>
                <Col allPl={0}>
                  <Checkbox
                    value={this.state.needLink}
                    schema={{
                      label: 'Создать ссылку на тему'
                    }}
                    onChange={() => {
                      this.setState({ needLink: !this.state.needLink });
                    }}
                    withIcon
                    noError
                  />
                </Col>
                <Col allPr={0}>
                  <Button
                    onClick={() => this.moveTopics(listBoxItems)}
                    label="Переместить тему"
                    iconType={iconTypes.newTab}
                    theme={btnThemes.sky}
                    contentLeft
                    big
                  />
                </Col>
              </Row>
            </Fixed>
          </LayoutContainer>
        </div>
      </ScrollComponent>
    );
  }
}
